import { isEmpty } from 'lodash';
import Cookies from 'js-cookie';

import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function setToken({ commit, state }, token) {
  commit(types.SET_TOKEN, token);

  return Promise.resolve(token);
}

export function setDevice({ commit, state }, device) {
  commit(types.SET_DEVICE, device);

  return Promise.resolve(device);
}

export function setSkipLanding(_, skipLanding) {
  Cookies.set('skip_landing_page_v2', skipLanding, { expires: 999 });

  return Promise.resolve(skipLanding);
}

export function fetchUser({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/users/me`)
    .then(res => (
      dispatch('setUserInStore', res.data)
    ))
    .catch((err) => {
      if (err.response && err.response.status === 404) {
        console.error('user not found in DB!');
        return dispatch('signIn');
      }

      return Promise.reject(err);
    })
    .then(() => (
      dispatch('syncClasses')
    ))
    .catch((err) => {
      dispatch('setToken', '');
      return Promise.reject(err);
    });
}

export function signIn({ dispatch }) {
  return http.post(`${MINERVA_API_URL}/users/sign-in`, {})
    .then(res => (
      dispatch('setUserInStore', res.data)
    ))
    .then(() => (
      dispatch('checkUserTutorial')
    ))
    .then(() => (
      Promise.all([
        dispatch('fetchSubjectList'),
        dispatch('fetchGradeList'),
        dispatch('syncClasses'),
        dispatch('fetchAdvertisement'),
      ])
    ))
    .catch((err) => {
      dispatch('setToken', '');
      return Promise.reject(err);
    });
}

export function updateUser({ dispatch }, updateInfo) {
  return http.patch(`${MINERVA_API_URL}/users/me`, updateInfo)
    .catch(err => Promise.reject(err));
}


export function setUserInStore({ commit }, userInfo) {
  commit(types.SET_USER, userInfo);

  return Promise.resolve(userInfo);
}

export function setUserPropertyInStore({ commit }, setInfo) {
  commit(types.SET_PROPERTY, setInfo);

  return Promise.resolve();
}

export function signOut({ commit }) {
  commit(types.SIGN_OUT);

  return Promise.resolve();
}

export function checkUserToken({ state }) {
  if (!isEmpty(state.token)) {
    return Promise.resolve(state.token);
  }

  return Promise.reject('NO_TOKEN');
}



// WEBPACK FOOTER //
// ./src/app/auth/store/actions.js